import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="パンくずリスト" className="bg-white border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-3">
        <ol className="flex items-center flex-wrap gap-1.5 text-xs text-gray-400">
          <li className="flex items-center gap-1.5">
            <div className="w-3 h-3 flex items-center justify-center flex-shrink-0">
              <i className="ri-home-4-line text-gray-400 text-xs"></i>
            </div>
            <Link to="/" className="hover:text-primary transition-colors cursor-pointer whitespace-nowrap">
              ホーム
            </Link>
          </li>
          {items.map((item, idx) => (
            <li key={idx} className="flex items-center gap-1.5">
              <div className="w-3 h-3 flex items-center justify-center flex-shrink-0">
                <i className="ri-arrow-right-s-line text-gray-300 text-xs"></i>
              </div>
              {item.href ? (
                <Link to={item.href} className="hover:text-primary transition-colors cursor-pointer whitespace-nowrap">
                  {item.label}
                </Link>
              ) : (
                <span className="text-gray-600 font-medium whitespace-nowrap">{item.label}</span>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
}
